<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color:' + ConfigData.FontColorTitle">{{
            $t("serviceTheme")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color:' + ConfigData.FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row style="margin-bottom: 1rem;">
            <v-col cols="6" class="mt-3"> </v-col>
            <v-col cols="6" justify="end" align="end">
              <v-btn v-if="!isViewOnly" color="primary" id="button-setdefault-configtheme" class="primary white--text mt-3 mr-3" :loading="dialog"
                :disabled="dialog" @click="setDefault">
                <v-icon size="20" style="padding-right: 5px">mdi-restore</v-icon>{{ $t('reset') }}
              </v-btn>
              <v-btn v-if="!isViewOnly" color="success" id="button-save-configtheme" class="green white--text mt-3" :loading="dialog" :disabled="dialog"
                @click="save">
                <v-icon size="20" style="padding-right: 5px">mdi-check-circle-outline</v-icon>{{ $t('save') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-expansion-panels v-model="panel">

            <!-- Login -->
            <v-expansion-panel>
              <v-expansion-panel-title>
                Login
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-card style="box-shadow: none !important; background-color: #ffffff;">
                        <div
                          style="border-width: 2px 2px 0px 2px; border-color: #BDBDBD; border-style:double; border-radius: 12px 12px 0px 0px; background-color: #00bfa5 ;">
                          <v-card-title class="text-white" style="display: flex;justify-content: space-between;"> Logo
                            <v-btn id="button-setdefault-logologin-configtheme" class="text-white" color="primary"
                              @click="setAsDefault('Loginlogo')">
                              <v-icon size="20" style="padding-right: 5px">mdi-restore</v-icon>
                              {{ $t('default') }}</v-btn>
                          </v-card-title>
                        </div>
                        <DragDropFile :dialog="true" :DragDrop="true" :accept="'image/*'"
                          @filesUploaded="onFileChange($event, 'Loginlogo')" :multiple="false" :ShowListFile="false"
                          class="UploadFile" />
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card style="background-color: #ffffff;  width: 600px; height: 400px;">
                        <div align="center">
                          <v-row justify="center" class="img-intersection">
                            <v-col cols="12" sm="8" md="8">
                              <v-img justify-center :src="images.Loginlogo" contain max-width="200" max-height="100" />
                              <v-form align="left" class="form">
                                <label>{{ $t('username') }}</label>
                                <v-text-field variant="outlined" class="mt-4" name="login" type="text" disabled density="compact" />
                                <label>{{ $t('password') }}</label>
                                <v-text-field variant="outlined" class="mt-4" append-inner-icon="mdi-eye-off" type="password" disabled
                                  density="compact" />
                                <v-btn class="login" size="large" align="center" justify="center">{{ $t('login') }}</v-btn>
                              </v-form>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <!-- Chat panel -->
            <v-expansion-panel>
              <v-expansion-panel-title id="chatpanel-expansion-panel-header-configtheme">
                Chat panel
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-text-field id="chatbotname-field-configtheme" v-model="ConfigData.ChatbotName"
                        :color="ConfigData.chatColorTheme"
                        hide-details label="Chatbot name" variant="outlined" density="compact" style="max-width: 500px;">
                        <template v-slot:prepend>
                          <v-menu location="bottom">
                            <template v-slot:activator="{ props }">
                              <v-btn variant="text" style=" justify-content: center;align-items: center; margin-top:-8px;"
                                v-bind="props" :color="ConfigData.chatColorTheme" icon>
                                <v-img v-if="ConfigData.isImgIconChat"
                                  style="height: 36px; width: 36px; border-radius: 50%;" :src="images.ChatbotIcon" />
                                <v-icon :color="ConfigData.chatColorTheme" v-else>{{ ConfigData.ChatbotIcon }}</v-icon>
                              </v-btn>
                            </template>
                            <v-list class="py-0">
                              <v-list-item v-for="(item, index) in itemsIcon" :key="index" link
                                @click="itemsIcon.length - 1 != index ? (ConfigData.ChatbotIcon = item.icon, ConfigData.isImgIconChat = false) : ''"
                                :class="itemsIcon.length - 1 != index ? '' : 'px-0'">
                                <v-list-item-title v-if="itemsIcon.length - 1 != index">
                                  <v-icon :color="ConfigData.chatColorTheme">{{ item.icon }}</v-icon>
                                </v-list-item-title>
                                <v-list-item-title v-else>
                                  <label
                                    style="display: flex; flex:column; columns: 12em; line-height: 2.5; font-size: 14px; cursor: pointer; justify-content: center;"
                                    for="img-upload">
                                    {{ item.title }} </label>
                                  <input type="file" id="img-upload" name="avatar" class="d-none" accept="image/*"
                                    @change="inputChatIcon($event)" />
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </template>
                        <template v-slot:append>
                          <v-btn icon style="margin-top: -8px; margin-bottom: 8px;"
                            @click="setAsDefault('ChatbotIcon')">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                      <v-color-picker id="chatcolortheme-chatpanel-configtheme"
                        v-model="ConfigData.chatColorTheme" mode="hex" width="500" hide-mode-switch
                        show-swatches :swatches="swatches"></v-color-picker>
                    </v-col>
                    <v-col cols="6">
                      <div class="d-flex flex-column pa-4 rounded-lg overflow-y-auto" style="width: 100%;"
                        :style="'max-height: 50vh; height:50vh; border: 3px solid' + ConfigData.chatColorTheme"
                        ref="LeftChat">
                        <div v-for="(item, index) in listMessage" v-bind:key="index">
                          <div class="d-flex flex-column justify-end">
                            <div class="float-right">
                              <div style="float: right; height: 35px; width: 35px; border-radius: 50%;
                                          text-align: center;  background-color: white; 
                                          margin-top: 10px; margin-left: 15px;">
                                <v-icon style="font-size: 30px;" :style="'color:' + ConfigData.chatColorTheme + ';'">
                                  mdi-account</v-icon>
                              </div>
                              <div style="float: right; margin-top:8px">
                                <label style="font-size: 14px; ">You</label>
                              </div>
                            </div>
                            <div class="float-right">
                              <label class="rounded-lg rounded-tr-0" style="line-break: anywhere; 
                              padding: 14px 20px;
                              font-size: 14px; font-weight: 400; color: #71717A; float: right;
                              line-height: 22px; white-space: pre-line; width: fit-content; 
                              min-height: 54px; max-width: 80%;">{{ item.messageUser }}</label>
                            </div>
                          </div>

                          <div class="d-flex flex-column justify-start">
                            <div class="float-left">
                              <div style="float: left; height: 35px; width: 35px; border-radius: 50%;
                                          text-align: center;  background-color: white; 
                                          margin-top: 10px; margin-right: 15px;">
                                <v-img v-if="ConfigData.isImgIconChat"
                                  style="height: 36px; width: 36px; border-radius: 50%;" :src="images.ChatbotIcon" />
                                <v-icon v-else style="font-size: 30px;"
                                  :style="'color:' + ConfigData.chatColorTheme + ';'">{{ ConfigData.ChatbotIcon }}</v-icon>
                              </div>
                              <div style="float: left; margin-top:8px">
                                <label style="font-size: 14px;">{{ ConfigData.ChatbotName }}</label>
                              </div>
                            </div>
                            <div class="float-left">
                              <label class="rounded-lg rounded-tr-0" style="line-break: anywhere;
                                padding: 14px 20px; border-radius: 8px; font-size: 14px; 
                                font-weight: 400; color: #71717A; float: left;
                                line-height: 22px; white-space: pre-line; width: fit-content;
                                min-height: 54px; max-width: 80%;">{{ item.messageBot }}</label>
                            </div>
                          </div>
                        </div>
                        <div ref="endLeft"></div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <!-- Header -->
            <v-expansion-panel>
              <v-expansion-panel-title id="header-expansion-panel-header-configtheme">
                Header
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-card rounded class="mb-4"
                        style="box-shadow: none !important; background-color: #ffffff; height: 62px !important;">
                        <v-toolbar :image="images.navBG" style="box-shadow: none !important; background-color: #ffffff; height: 62px !important; 
                          background-position: center !important; background-size: cover !important;">
                          <v-toolbar-title>
                            <v-img :src="images.navlogo" max-width="100" max-height="48" contain />
                          </v-toolbar-title>
                          <v-spacer />
                          <label :style="'color:' + ConfigData.NavbarTxtColorTheme"
                            style="font-size: 12px; margin-right:12px; margin-bottom:0px; margin-top:30px;"> Version
                            R1.xx.x</label>

                          <v-btn icon="fab" size="small" :style="'background:' + ConfigData.NavbarBtnColorTheme" class="mr-4">
                            <flag iso="us" />
                          </v-btn>
                          <v-btn :style="'background:' + ConfigData.NavbarBtnColorTheme"
                            style="border-radius: 25px; color: #ffffff">
                            <span :style="'color:' + ConfigData.NavbarTxtColorTheme"> Username </span>
                            <span>
                              <v-icon>mdi-menu-down</v-icon>
                            </span>
                          </v-btn>
                        </v-toolbar>
                      </v-card>
                      <v-row>
                        <v-col cols="6">
                          <div
                            style=" border-width: 2px 2px 0px 2px; border-color: #BDBDBD; border-style:double; border-radius: 12px 12px 0px 0px; background-color: #00bfa5;">
                            <v-card-title class="text-white" style="display: flex; justify-content: space-between;"> 
                              Button color 
                              <v-btn id="button-setdefault-buttoncolor-configtheme" color="primary" class="text-white ml-4"
                                @click="setAsDefault('ButtonColor')">
                                <v-icon size="20" style="padding-right: 5px">mdi-restore</v-icon>
                                {{ $t('default') }}</v-btn> 
                            </v-card-title>
                          </div>
                          <div
                            style="display: grid; align-items: center; justify-content: center; 
                                border: 2px dashed #bdbdbd !important; border-radius: 0px 0px 8px 8px; padding: 0px 16px 16px 16px;">
                            <v-color-picker class="mt-4" id="navbarbtncolortheme-header-configtheme"
                              v-model="ConfigData.NavbarBtnColorTheme" mode="hex" width="500"
                              hide-mode-switch show-swatches :swatches="swatches"></v-color-picker>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div
                            style="border-width: 2px 2px 0px 2px; border-color: #BDBDBD; border-style:double; border-radius: 12px 12px 0px 0px; background-color: #00bfa5;">
                            <v-card-title class="text-white" style="display: flex; justify-content: space-between;"> Text color 
                              <v-btn id="button-setdefault-textcolor-configtheme" color="primary" class="text-white"
                                @click="setAsDefault('TextColor')">
                                <v-icon size="20" style="padding-right: 5px">mdi-restore</v-icon>
                                {{ $t('default') }}</v-btn>
                            </v-card-title>
                          </div>
                          <div
                            style="display: grid; align-items: center; justify-content: center; 
                                border: 2px dashed #bdbdbd !important; border-radius: 0px 0px 8px 8px; padding: 0px 16px 16px 16px;">
                            <v-color-picker class="mt-4" id="navbartxtcolortheme-header-configtheme"
                              v-model="ConfigData.NavbarTxtColorTheme" mode="hex" width="500"
                              hide-mode-switch show-swatches :swatches="swatches"></v-color-picker>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-card style="box-shadow: none !important; background-color: #ffffff;">
                            <div
                              style="border-width: 2px 2px 0px 2px; border-color: #BDBDBD; border-style:double; border-radius: 12px 12px 0px 0px; background-color: #00bfa5;">
                              <v-card-title class="text-white" style="display: flex; justify-content: space-between;"> {{ $t('headerLogo') }}
                                <v-btn id="button-navlogo-header-configtheme" color="primary" class="text-white"
                                  @click="setAsDefault('NavLogo')">
                                  <v-icon size="20" style="padding-right: 5px">mdi-restore</v-icon>
                                  {{ $t('default') }}</v-btn>
                              </v-card-title>
                            </div>
                            <DragDropFile :dialog="true" :DragDrop="true" :accept="'image/*'"
                              @filesUploaded="onFileChange($event, 'NavLogo')" :multiple="false" :ShowListFile="false"
                              class="UploadFile" />
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <v-card style="box-shadow: none !important; background-color: #ffffff;">
                            <div
                              style="border-width: 2px 2px 0px 2px; border-color: #BDBDBD; border-style:double; border-radius: 12px 12px 0px 0px; background-color: #00bfa5 ;">
                              <v-card-title class="text-white" style="display: flex; justify-content: space-between;"> {{ $t('background') }}
                                <v-btn id="button-navbackground-header-configtheme" color="primary" class="text-white"
                                  @click="setAsDefault('NavBG')">
                                  <v-icon size="20" style="padding-right: 5px">mdi-restore</v-icon>
                                  {{ $t('default') }}</v-btn>
                              </v-card-title>
                            </div>
                            <DragDropFile :dialog="true" :DragDrop="true" :accept="'image/*'"
                              @filesUploaded="onFileChange($event, 'NavBG')" :multiple="false" :ShowListFile="false"
                              class="UploadFile" />
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                    </v-col>
                  </v-row>
                </v-col>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <!-- Title -->
            <v-expansion-panel>
              <v-expansion-panel-title id="title-expansion-panel-header-configtheme">
                Title
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-card rounded class="mt-6 mb-4"
                        style="box-shadow: none !important; background-color: #ffffff; height: 62px !important;">
                        <v-toolbar :image="images.subNavBG" style="box-shadow: none !important; background-color: #ffffff; height: 62px !important; 
                            background-position: center !important; background-size: cover !important;">
                          <v-toolbar-title class="title" :style="'color:' + ConfigData.FontColorTitle">Demo
                          </v-toolbar-title>
                          <v-spacer />
                          <div class="d-flex pr-4">
                             <v-toolbar-title class="title"
                              :style="'color:' + ConfigData.FontColorTitle">{{ today }}
                              </v-toolbar-title>
                          </div>
                        </v-toolbar>
                      </v-card>
                      <v-row>
                        <v-col cols="6">
                          <v-card style="box-shadow: none !important; background-color: #ffffff;">
                            <div
                              style="border-width: 2px 2px 0px 2px; border-color: #BDBDBD; border-style:double; border-radius: 12px 12px 0px 0px; background-color: #00bfa5 ;">
                              <v-card-title class="text-white" style="display: flex;justify-content: space-between;"> Font color 
                                <v-btn id="button-fontcolor-title-configtheme" color="primary" class="text-white"
                                  @click="setAsDefault('FontColor')">
                                  <v-icon size="20" style="padding-right: 5px">mdi-restore</v-icon>
                                  {{ $t('default') }}</v-btn> </v-card-title>
                            </div>
                            <div
                              style="display: grid; align-items: center; justify-content: center; 
                                  border: 2px dashed #bdbdbd !important; border-radius: 0px 0px 8px 8px; padding: 16px 16px 16px 16px;">
                              <v-color-picker id="fontcolortitle-title-configtheme" v-model="ConfigData.FontColorTitle"
                                mode="hex" hide-mode-switch width="500"
                                show-swatches :swatches="swatches"></v-color-picker>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="6">
                          <v-card style="box-shadow: none !important; background-color: #ffffff;">
                            <div
                              style="border-width: 2px 2px 0px 2px; border-color: #BDBDBD; border-style:double; border-radius: 12px 12px 0px 0px; background-color: #00bfa5 ;">
                              <v-card-title class="text-white" style="display: flex; justify-content: space-between;" > {{ $t('background') }}
                                <v-btn id="button-subbg-title-configtheme" color="primary" class="text-white"
                                  @click="setAsDefault('SubBG')">
                                  <v-icon size="20" style="padding-right: 5px">mdi-restore</v-icon>
                                  {{ $t('default') }}</v-btn>
                              </v-card-title>
                            </div>
                            <DragDropFile :dialog="true" :DragDrop="true" :accept="'image/*'"
                              @filesUploaded="onFileChange($event, 'SubBG')" :multiple="false" :ShowListFile="false"
                              class="UploadFile" />
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                    </v-col>
                  </v-row>
                </v-col>
              </v-expansion-panel-text>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-flex>
      </v-card>
      <v-overlay :value="dialog">
        <v-dialog v-model="dialog" persistent width="300">
          <v-card color="#1976D2" dark>
            <v-card-text class="white--text">
              Loading Please Wait...
              <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
// import LogTrace from "@/api/function.js";
import DragDropFile from '@/components/DragDropFile.vue';
import LoginlogoImg from "@/assets/images/chatframework 1.png";
import navlogoImg from "@/assets/images/logo-removebg-preview@3x.png";
import navBGImg from "@/assets/images/gradient-abstract-style-wireframe-background 1.png";
import subNavBGImg from "@/assets/images/Rectangle 51.png";

export default {
  components: { DragDropFile },
  inject: ["flagNav", "getIMG", "getStartUpImage", "configColor", "LoginLogo", "IconChat", "NavbarIcon",
    "NavbarBackGround", "SubNavbarBackGround", "ChatbotName", "ChatbotIcon", "FontColorTitle", "colorThemeChat", "NavbarBtnColorTheme", "NavbarTxtColorTheme"
  ],
  name: "ConfigTheme",
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    dialog: false,
    today: null,
    images: {
      Loginlogo: LoginlogoImg,
      navlogo: navlogoImg,
      navBG: navBGImg,
      subNavBG: subNavBGImg,
      ChatbotIcon: null,
    },
    panel: 0,
    itemsIcon: [
      { icon: 'mdi-robot-outline' },
      { icon: 'mdi-face-agent' },
      { icon: 'mdi-face-man-shimmer' },
      { icon: 'mdi-face-woman-shimmer' },
      { icon: 'mdi-account-circle-outline' },
      { icon: 'mdi-creation-outline' },

      { icon: '', title: 'More' }
    ],
    ConfigData: {
      ChatbotName: "Chatbot",
      ChatbotIcon: "mdi-robot-outline",
      FontColorTitle: '#FFFFFF',
      chatColorTheme: '#FFA41E',
      NavbarBtnColorTheme: '#5179EF',
      NavbarTxtColorTheme: '#FFFFFF',

      isImgIconChat: false,
      ChatIcon: null,
      Loginlogo: null,
      navlogo: null,
      navBG: null,
      subNavBG: null,
    },
    swatches: [
      ['#FF0000', '#AA0000'],
      ['#FF8800', '#AF5800'],
      // ['#FFFF00', '#AAAA00'],
      ['#00FF00', '#00AA00'],
      ['#00FFFF', '#00AAAA'],
      ['#0000FF', '#0000AA'],
    ],
    files: null,
    listMessage: [
      {
        messageUser: "Hi",
        messageBot: "Hello",
        status_Process: "END",
      },
      {
        messageUser: "FOO",
        messageBot: "BAR",
        status_Process: "END",
      }
    ],
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ServiceTheme');
    },
    loginLogoC() {
      return this.LoginLogo;
    },
    iconChat() {
      return this.IconChat;
    },
    NavbarIconC() {
      return this.NavbarIcon;
    },
    NavbarBackGroundC() {
      return this.NavbarBackGround;
    },
    subNavbarBackGroundC() {
      return this.SubNavbarBackGround;
    },
    chatbotNameC() {
      return this.ChatbotName;
    },
    chatbotIconC() {
      return this.ChatbotIcon;
    },
    fontColorTitleC() {
      return this.FontColorTitle;
    },
    ColorThemeChatC() {
      return this.colorThemeChat;
    },
    navbarBtnColorTheme() {
      return this.NavbarBtnColorTheme;
    },
    navbarTxtColorTheme() {
      return this.NavbarTxtColorTheme;
    },

  },
  watch: {
    loginLogoC(newValue) {
      this.images.Loginlogo = `${newValue}`;
    },
    iconChat(newValue) {
      this.images.IconChat = `${newValue}`;
    },
    NavbarIconC(newValue) {
      this.images.NavbarIcon = `${newValue}`;
    },
    NavbarBackGroundC(newValue) {
      this.images.NavbarBackGround = `'${newValue}'`;
    },
    subNavbarBackGroundC(newValue) {
      this.images.SubNavbarBackGround = `${newValue}`;
    },
    chatbotNameC(newValue) {
      this.ConfigData.ChatbotName = `${newValue}`;
    },
    chatbotIconC(newValue) {
      this.ConfigData.ChatbotIcon = `${newValue}`;
    },
    fontColorTitleC(newValue) {
      this.ConfigData.FontColorTitle = `#${newValue}`;
    },
    ColorThemeChatC(newValue) {
      this.ConfigData.colorThemeChat = `#${newValue}`;
    },
    navbarBtnColorTheme(newValue) {
      this.ConfigData.NavbarBtnColorTheme = `#${newValue}`;
    },
    navbarTxtColorTheme(newValue) {
      this.ConfigData.NavbarTxtColorTheme = `#${newValue}`;
    },
  },

  mounted() {
    this.GetDate();
    this.Get();
  },
  methods: {
    async Get() {
      let self = this;
      try {
        const [data, loginLogoC, chatIcon, navLogo, navBG, subBG] = await Promise.all([
          new Promise((resolve) => { self.$call.GetConfigThem((response) => { resolve(response.data); }); }),
          self.getIMG("LoginLogo.png"),
          self.getIMG("ChatIcon.png"),
          self.getIMG("NavLogo.png"),
          self.getIMG("NavBG.png"),
          self.getIMG("SubBG.png"),
        ]);
        if (data) {
          self.ConfigData.ChatbotName = data.nameChat || self.ConfigData.ChatbotName;
          self.ConfigData.ChatbotIcon = data.isImgIconChat == true ? "" : data.iconChat || self.ConfigData.ChatbotIcon;
          self.ConfigData.FontColorTitle = data.fontColorTitle ? `#${data.fontColorTitle}` : self.ConfigData.FontColorTitle;
          self.ConfigData.chatColorTheme = data.colorThemeChat ? `#${data.colorThemeChat}` : self.ConfigData.chatColorTheme;
          self.ConfigData.NavbarBtnColorTheme = data.navbarButton ? `#${data.navbarButton}` : self.ConfigData.NavbarBtnColorTheme;
          self.ConfigData.NavbarTxtColorTheme = data.navbarColorText ? `#${data.navbarColorText}` : self.ConfigData.NavbarTxtColorTheme;
          self.ConfigData.isImgIconChat = data.isImgIconChat;
        }
        self.images.ChatbotIcon = chatIcon;
        self.images.Loginlogo = loginLogoC || self.images.Loginlogo;
        self.images.navlogo = navLogo || self.images.navlogo;
        self.images.navBG = navBG || self.images.navBG;
        self.images.subNavBG = subBG || self.images.subNavBG;

        self.dialog = false;
      } catch (error) {
        console.error("An error occurred while loading config:", error);
      }
    },
    convertUTCDateToLocalDate(date) {
      date = new Date(date);

      let timezone = date.getTimezoneOffset() * 60000;
      let newDate = new Date(date.getTime() - timezone);
      let output =
        newDate.getDate() +
        "/" +
        newDate.getMonth() +
        "/" +
        newDate.getFullYear() +
        "   " +
        newDate.getHours() +
        ":" +
        newDate.getMinutes();

      return output;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    createImage(file, name) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // Convert to base64
        if (name == "Loginlogo") {
          this.images.Loginlogo = e.target.result;
        }
        else if (name == "ChatbotIcon") {
          this.images.ChatbotIcon = e.target.result;
        }
        else if (name == "NavLogo") {
          this.images.navlogo = e.target.result;
        }
        else if (name == "NavBG") {
          this.images.navBG = e.target.result;
        }
        else if (name == "SubBG") {
          this.images.subNavBG = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    async inputChatIcon(evt) {
      let self = this;
      let file = evt.target.files;//[0]
      if (file.length > 0) {
        let data = file[0];
        const flagUpload = await self.CheckSizeIMG(data, 1024, 1024, 2);
        if (flagUpload) {
          self.ConfigData.isImgIconChat = true;
          self.onFileChange(file, 'ChatbotIcon')
        }
      } else {
        return;
      }
    },
    async CheckSizeIMG(file, limitFile) {
      let self = this;
      const maxFileSize = limitFile * 1024 * 1024;
      // ตรวจสอบขนาดของไฟล์

      return new Promise((resolve) => {
        if (file.size > maxFileSize) {
          self.$swal.fire({
            title: self.$t('warning'),
            text: `ขนาดไฟล์เกิน ${limitFile} MB`,
            icon: 'warning',
            showConfirmButton: false,
            timer: 3000,
          })
          resolve(false);
          return;
        } else {
          resolve(true);
        }
      })
    },
    async onFileChange(file, name) {
      let self = this;
      let data = file[0];
      let maximunWidth = 0;
      let maximunHeight = 0;
      var flagUpload
      const img = new Image();
      const objectURL = URL.createObjectURL(data);
      img.src = objectURL;
      if (!file) {
        return;
      }
      if (name == "Loginlogo") {
        maximunWidth = 1024;
        maximunHeight = 1024;
        flagUpload = await self.CheckSizeIMG(data, 2);
        if (flagUpload) {
          img.onload = () => {
            if (img.width > maximunWidth || img.height > maximunHeight) {
              self.$swal.fire({
                title: self.$t('warning'),
                text: `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
                icon: 'warning',
                showConfirmButton: false,
                timer: 3000,
              });
              return;
            } else {
              self.ConfigData.Loginlogo = data;
              this.createImage(data, name);
            }
            URL.revokeObjectURL(objectURL);
          }
        } else {
          return;
        }
      }
      else if (name == "ChatbotIcon") {
        maximunWidth = 800;
        maximunHeight = 800;
        flagUpload = await self.CheckSizeIMG(data, 2);
        if (flagUpload) {
          img.onload = () => {
            if (img.width > maximunWidth || img.height > maximunHeight) {
              self.$swal.fire({
                title: self.$t('warning'),
                text: `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
                icon: 'warning',
                showConfirmButton: false,
                timer: 3000,
              });
              return;
            } else {
              self.ConfigData.ChatbotIcon = data;
              this.createImage(data, name);
            }
            URL.revokeObjectURL(objectURL);
          }
        } else {
          return;
        }
      }
      else if (name == "NavLogo") {
        maximunWidth = 2560;
        maximunHeight = 1440;
        flagUpload = await self.CheckSizeIMG(data, 2);
        if (flagUpload) {
          img.onload = () => {
            if (img.width > maximunWidth || img.height > maximunHeight) {
              self.$swal.fire({
                title: self.$t('warning'),
                text: `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
                icon: 'warning',
                showConfirmButton: false,
                timer: 3000,
              });
              return;
            } else {
              self.ConfigData.navlogo = data;
              this.createImage(data, name);
            }
            URL.revokeObjectURL(objectURL);
          }
        } else {
          return;
        }
      }
      else if (name == "NavBG") {
        maximunWidth = 2560;
        maximunHeight = 1440;
        flagUpload = await self.CheckSizeIMG(data, 2);
        if (flagUpload) {
          img.onload = () => {
            if (img.width > maximunWidth || img.height > maximunHeight) {
              self.$swal.fire({
                title: self.$t('warning'),
                text: `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
                icon: 'warning',
                showConfirmButton: false,
                timer: 3000,
              });
              return;
            } else {
              self.ConfigData.navBG = data;
              this.createImage(data, name);
            }
            URL.revokeObjectURL(objectURL);
          }
        } else {
          return;
        }
      }
      else if (name == "SubBG") {
        maximunWidth = 2560;
        maximunHeight = 1440;
        flagUpload = await self.CheckSizeIMG(data, 2);
        if (flagUpload) {
          img.onload = () => {
            if (img.width > maximunWidth || img.height > maximunHeight) {
              self.$swal.fire({
                title: self.$t('warning'),
                text: `ขนาดรูปภาพต้องไม่เกิน ${maximunWidth}x${maximunHeight} พิกเซล`,
                icon: 'warning',
                showConfirmButton: false,
                timer: 3000,
              });
              return;
            } else {
              self.ConfigData.subNavBG = data;
              this.createImage(data, name);
            }
            URL.revokeObjectURL(objectURL);
          }
        } else {
          return;
        }
      }
      // this.createImage(data,name);
    },
    setAsDefault(txt) {
      let self = this;
      switch (txt) {
        case "Loginlogo":
          {
            self.images.Loginlogo = LoginlogoImg
            self.ConfigData.Loginlogo = false;
            break;
          }
        case "ChatbotIcon": {
          self.ConfigData.isImgIconChat = false;
          self.ConfigData.ChatbotIcon = "mdi-robot-outline";
          self.ConfigData.chatColorTheme = "#FFA41E";
          self.ConfigData.ChatbotName = "Chatbot";
          break;
        }
        case "NavLogo": {
          self.images.navlogo = navlogoImg;
          self.ConfigData.navlogo = false;
          break;
        }
        case "NavBG": {
          self.images.navBG = navBGImg;
          self.ConfigData.navBG = false;
          break;
        }
        case "SubBG": {
          self.images.subNavBG = subNavBGImg;
          self.ConfigData.subNavBG = false;
          break;
        }
        case "ButtonColor": {
          self.ConfigData.NavbarBtnColorTheme = "#5179EF";
          break;
        }
        case "TextColor": {
          self.ConfigData.NavbarTxtColorTheme = "#FFFFFF";
          break;
        }
        case "FontColor": {
          self.ConfigData.FontColorTitle = "#FFFFFF";
          break;
        }
        default:
          break;
      }
    },
    setDefault() {
      let self = this;
      self.$swal.fire({
        title: this.$t('confirmToSetDefault'),
        text: this.$t('infoconfirmToSetDefault'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: false,
      })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            self.$call.SetDefault((dataResponse) => {
              self.dialog = false;
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.GetStartUpImage;
                self.configColor;
              }
              window.location.reload();
            },
              (errorResource) => {
                self.dialog = false;
                console.error(errorResource);
              }
            );
          }
        })
    },
    save() {
      let self = this;
      self.dialog = true;
      let isImgChat = self.ConfigData.isImgIconChat ?? false;
      let setDefault = [];
      if (self.ConfigData.Loginlogo == false) { setDefault.push(1); }
      if (self.ConfigData.navlogo == false) { setDefault.push(2); }
      if (self.ConfigData.navBG == false) { setDefault.push(3); }
      if (self.ConfigData.subNavBG == false) { setDefault.push(4); }
      if (self.ConfigData.ChatbotIcon == "mdi-robot-outline" && self.ConfigData.isImgIconChat == false) { setDefault.push(5); }
      const setDefaultJson = JSON.stringify(setDefault);
      const formData = new FormData()
      formData.append('Loginlogo', self.ConfigData.Loginlogo);
      formData.append('NavLogo', self.ConfigData.navlogo);
      formData.append('NavBG', self.ConfigData.navBG);
      formData.append('SubBG', self.ConfigData.subNavBG);
      if (isImgChat == true) { formData.append('ChatIcon', self.ConfigData.ChatbotIcon ?? ""); }
      let data = {
        ChatbotName: self.ConfigData.ChatbotName,
        ChatbotIcon: isImgChat == true ? "" : self.ConfigData.ChatbotIcon,
        FontColorTitle: self.ConfigData.FontColorTitle.replace("#", ""),
        chatColorTheme: self.ConfigData.chatColorTheme.replace("#", ""),
        NavbarBtnColorTheme: self.ConfigData.NavbarBtnColorTheme.replace("#", ""),
        NavbarTxtColorTheme: self.ConfigData.NavbarTxtColorTheme.replace("#", ""),
        setDefaultJson: setDefaultJson,

        formData: formData,
      }
      self.$call.UploadTheme(data, (dataResponse) => {
        if (dataResponse.status == 0) {
          self.$swal.fire({
            icon: 'success',
            title: dataResponse.message,
            showConfirmButton: false,
            timer: 1500,
          });
          self.GetStartUpImage;
          self.configColor;
          self.dialog = false;
          window.location.reload();
        }
      },
        (err) => {
          console.log(err)
          self.dialog = false;
        }
      )
    },
    handleFileImport() {
      this.$refs.uploader.click();
    },
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.pagin {
  margin-top: 1.5rem;
}

.flex {
  margin: 2rem;
  /* margin-right: 2rem; */
}

.img-intersection {
  width: 100%;
  height: 100%;
  max-width: 100%;
}
</style>